import React, {createContext, useCallback, useContext, useEffect, useState} from "react"
import RequestState from "../../../util/RequestState"
import {ClubChargeApi} from "../../../api/clubChagre"


const initialState = {
    getChargeState: RequestState.Loading,
    getLevelState: RequestState.Loading,
    getPaymentState: RequestState.Loading,
    getChargeTableListState: RequestState.Loading,
    getTableListState: RequestState.Loading,
    addOrUpdateChargeState: RequestState.Idle,
    deleteChargeState: RequestState.Idle,
    getChargeList: async () => {
    },
    getChargeTableList: async () => {
    },
    addOrUpdateCharge: async () => {
    },
    deleteCharge: async (id) => {

    }
}

export const ClubChargeContext = createContext(initialState)

export const ClubChargeProvider = (props) => {

    const [getChargeState, setGetChargeState] = useState(initialState.getChargeState)
    const [getLevelState, setGetLevelState] = useState(initialState.getLevelState)
    const [getPaymentState, setGetPaymentState] = useState(initialState.getPaymentState)
    const [getTableListState, setGetTableListState] = useState(initialState.getTableListState)
    const [getChargeTableListState, setGetChargeTableListState] = useState(initialState.getChargeTableListState)
    const [addOrUpdateChargeState, setAddOrUpdateChargeState] = useState(initialState.addOrUpdateChargeState)
    const [deleteChargeState, setDeleteChargeState] = useState(initialState.deleteChargeState)


    useEffect(() => {
        getChargeList()
    }, [])


    const getLevelList = useCallback(async () => {
        try {
            setGetLevelState(RequestState.Loading)
            const data = await ClubChargeApi.getLevelList()
            setGetLevelState(RequestState.Success(data))
        } catch (e) {
            setGetChargeState(RequestState.Error(data))
        }
    }, [getLevelState])

    const getChargeList = useCallback(async () => {
        try {
            setGetChargeState(RequestState.Loading)
            await getLevelList()
            await getPaymentList()
            const data = await ClubChargeApi.getClubCharge()
            if (data.coupon_balance.length === 0) {
                setGetChargeState(RequestState.Empty)
                return
            }
            setGetChargeState(RequestState.Success(data))
        } catch (e) {
            setGetChargeState(RequestState.Error(e))
        }
    }, [getChargeState])


    const getPaymentList = useCallback(async () => {
        try {
            setGetPaymentState(RequestState.Loading)
            const data = await ClubChargeApi.getPaymentList()
            setGetPaymentState(RequestState.Success(data))
        } catch (e) {
            setGetPaymentState(RequestState.Error(e))
        }

    }, [getPaymentState])

    const getTableList = async () => {
        try {
            setGetTableListState(RequestState.Loading)
            const response = await ClubChargeApi.getBaseTableList()
            if (response.status !== 1) {
                setGetChargeTableListState(RequestState.Error(response.detail))
                return
            }
            setGetTableListState(RequestState.Success(response.data))
        } catch (e) {
            setGetChargeTableListState(RequestState.Error(e))
        }
    }


    const getChargeTableList = async (planId) => {
        try {
            setGetChargeTableListState(RequestState.Loading)
            const tableChargeResponse = await ClubChargeApi.getChargeTableList({
                plan_id: planId
            })
            if (tableChargeResponse.status !== 1) {
                setGetChargeTableListState(RequestState.Error(tableChargeResponse.detail))
                return
            }
            await getTableList()
            setGetChargeTableListState(RequestState.Success(tableChargeResponse.data))
        } catch (e) {
            setGetChargeTableListState(RequestState.Error(e))
        }
    }

    const addOrUpdateCharge = async (param) => {
        try {
            setAddOrUpdateChargeState(RequestState.Loading)
            const response = await ClubChargeApi.updateCharge(param)
            if (response.status !== 1) {
                setAddOrUpdateChargeState(RequestState.Error(response.detail))
                return
            }
            setAddOrUpdateChargeState(RequestState.Success(response.data))
        } catch (e) {
            setAddOrUpdateChargeState(RequestState.Error(e))
        }
    }

    const deleteCharge = async (id) => {
        try {
            setDeleteChargeState(RequestState.Loading)
            const response = await ClubChargeApi.deleteCharge(id)
            if (!response.status) {
                setDeleteChargeState(RequestState.Error(response.detail))
                return
            }
            setDeleteChargeState(RequestState.Success(response.data))
        } catch (e) {
            setDeleteChargeState(RequestState.Error(e))
        }
    }

    const value = {
        getChargeState,
        getLevelState,
        getPaymentState,
        getTableListState,
        getChargeTableListState,
        addOrUpdateChargeState,
        deleteChargeState,
        getChargeList,
        getChargeTableList,
        addOrUpdateCharge,
        deleteCharge
    }

    return <ClubChargeContext.Provider value={value}>
        {props.children}
    </ClubChargeContext.Provider>
}


export const useClubChargeContext = () => {
    const context = useContext(ClubChargeContext)
    if (!context) {
        throw new Error('ClubLevelManagerContext must be used within a ClubLevelManagerProvider')
    }
    return context
}


// WEBPACK FOOTER //
// ./src/containers/ClubCharge/store/useClubChargeContext.js